/**
 * @fileoverview gRPC-Web generated client stub for accountpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: accountpb/contactinfo.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.accountpb = require('./contactinfo_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.ContactInfoServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.ContactInfoServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ContactInfo,
 *   !proto.accountpb.CreateContactInfoResponse>}
 */
const methodDescriptor_ContactInfoService_CreateContactInfo = new grpc.web.MethodDescriptor(
  '/accountpb.ContactInfoService/CreateContactInfo',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ContactInfo,
  proto.accountpb.CreateContactInfoResponse,
  /**
   * @param {!proto.accountpb.ContactInfo} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.CreateContactInfoResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ContactInfo} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.CreateContactInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.CreateContactInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ContactInfoServiceClient.prototype.createContactInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ContactInfoService/CreateContactInfo',
      request,
      metadata || {},
      methodDescriptor_ContactInfoService_CreateContactInfo,
      callback);
};


/**
 * @param {!proto.accountpb.ContactInfo} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.CreateContactInfoResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ContactInfoServicePromiseClient.prototype.createContactInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ContactInfoService/CreateContactInfo',
      request,
      metadata || {},
      methodDescriptor_ContactInfoService_CreateContactInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ContactInfo,
 *   !proto.accountpb.UpdateContactInfoResponse>}
 */
const methodDescriptor_ContactInfoService_UpdateContactInfo = new grpc.web.MethodDescriptor(
  '/accountpb.ContactInfoService/UpdateContactInfo',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ContactInfo,
  proto.accountpb.UpdateContactInfoResponse,
  /**
   * @param {!proto.accountpb.ContactInfo} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.UpdateContactInfoResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ContactInfo} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.UpdateContactInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.UpdateContactInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ContactInfoServiceClient.prototype.updateContactInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ContactInfoService/UpdateContactInfo',
      request,
      metadata || {},
      methodDescriptor_ContactInfoService_UpdateContactInfo,
      callback);
};


/**
 * @param {!proto.accountpb.ContactInfo} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.UpdateContactInfoResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ContactInfoServicePromiseClient.prototype.updateContactInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ContactInfoService/UpdateContactInfo',
      request,
      metadata || {},
      methodDescriptor_ContactInfoService_UpdateContactInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ReadContactInfoRequest,
 *   !proto.accountpb.ReadContactInfoResponse>}
 */
const methodDescriptor_ContactInfoService_ReadContactInfo = new grpc.web.MethodDescriptor(
  '/accountpb.ContactInfoService/ReadContactInfo',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ReadContactInfoRequest,
  proto.accountpb.ReadContactInfoResponse,
  /**
   * @param {!proto.accountpb.ReadContactInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ReadContactInfoResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ReadContactInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.ReadContactInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ReadContactInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ContactInfoServiceClient.prototype.readContactInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ContactInfoService/ReadContactInfo',
      request,
      metadata || {},
      methodDescriptor_ContactInfoService_ReadContactInfo,
      callback);
};


/**
 * @param {!proto.accountpb.ReadContactInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ReadContactInfoResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ContactInfoServicePromiseClient.prototype.readContactInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ContactInfoService/ReadContactInfo',
      request,
      metadata || {},
      methodDescriptor_ContactInfoService_ReadContactInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.DeleteContactInfoRequest,
 *   !proto.accountpb.DeleteContactInfoResponse>}
 */
const methodDescriptor_ContactInfoService_DeleteContactInfo = new grpc.web.MethodDescriptor(
  '/accountpb.ContactInfoService/DeleteContactInfo',
  grpc.web.MethodType.UNARY,
  proto.accountpb.DeleteContactInfoRequest,
  proto.accountpb.DeleteContactInfoResponse,
  /**
   * @param {!proto.accountpb.DeleteContactInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.DeleteContactInfoResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.DeleteContactInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.DeleteContactInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.DeleteContactInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ContactInfoServiceClient.prototype.deleteContactInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ContactInfoService/DeleteContactInfo',
      request,
      metadata || {},
      methodDescriptor_ContactInfoService_DeleteContactInfo,
      callback);
};


/**
 * @param {!proto.accountpb.DeleteContactInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.DeleteContactInfoResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ContactInfoServicePromiseClient.prototype.deleteContactInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ContactInfoService/DeleteContactInfo',
      request,
      metadata || {},
      methodDescriptor_ContactInfoService_DeleteContactInfo);
};


module.exports = proto.accountpb;

